import { TimesheetPeriodStatusEnum } from '../../enum/timesheet-period-status.enum';
import { TimeEntryStaffData } from './time-entry-staff-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class TimesheetPeriodData {
  TimesheetPeriodId: string;
  PercentageComplete: number;
  StartDate: string;
  Status: TimesheetPeriodStatusEnum;
  PreviousPercentageComplete: number;
  PreviousHoursSubmitted: number;
  PreviousCostSubmitted: number;
  Staffs: TimeEntryStaffData[];
}


